<template lang="pug">
div(:class="{'notice-container-': !noShowTitle, 'pt-0': noShowTitle, 'pinned-only': pinnedOnly && pinned.length > 0, 'in-stats': inStats, 'no-spacing': pinnedOnly && pinned.length == 0}")
  .fs-16.text-white-on-dark.pb-5(v-if="!noShowTitle && !pinnedOnly")
    b Latest News
  template(v-if="pinned.length > 0")
    .pinned-container
      .notice-(
          v-for="o in pinned"
        )
        .indicator-w-pin(:class="'is-' + o.type")
          i.fa.fa-thumb-tack
        .notice-content-(
          :class="{'new': o.at > lastNewsDate}"
        )
          .title-(v-html="o.title")
          .time-container-
            .time- {{ o.at | formatFullDate }}
            .tweet(v-if="o.tweet_url")
              div.separator-circle
              a.x-icon.hint--right(aria-label="View on X", :href="o.tweet_url", target="_blank")
                img(src="/img/icons/xlogo.png")
  //- .news-super-container(:class="{'mt-15': !noShowTitle}")
  .news-super-container(:class="{'display-none': pinnedOnly}")
    .box-shadow-container.top.box-shadow-container-top(v-show="showTopShadow")
    div(:id="id").notice-container.ml-15(
      :style="'max-height: ' + maxHeightStyle"
      :class="{'infinite-container': infiniteScroll}"
    )
      .notice-(
        v-for="o in list"
      )
        .indicator(:class="'is-' + o.type")
        .notice-content-(
          :class="{'new': o.at > lastNewsDate}"
          @click="clearNews"
        )
          .title-(v-html="o.title")
          .time-container-
            .time- {{ o.at | formatFullDate }}
            .tweet(v-if="o.tweet_url")
              div.separator-circle
              a.x-icon.hint--right(aria-label="View on X", :href="o.tweet_url", target="_blank")
                img(src="/img/icons/xlogo.png")
      .fs-13.text-white-on-dark.has-text-centered(v-if="isLoading") Loading...
      .more-news.ml-15.has-text-centered(v-if="!isLoading && !infiniteScroll")
        div.info-link(href='#', @click="loadMoreNews") 
          span More news
    .box-shadow-container.bottom.box-shadow-container-bottom(v-show="showBottomShadow")
</template>

<script>
import { nanoid } from 'nanoid'
import { apiGetSupportV4 } from '../util/general'
export default {
  name: 'c_news',
  data() {
    return {
      pinned: [],
      list: [],
      isLoading: false,
      infiniteScroll: false,
      containerHeight: 0,
      showTopShadow: false,
      showBottomShadow: false,
      noMoreFetch: false,
      isHoveringTop: false,
      isHoveringBottom: false,
      isDown: false,
      startY: 0,
      scrollTop: 0,
      scrollMovement: 10,
      countDesktop: 4,
      countMobile: 2
    }
  },
  props: ['noShowTitle', 'pinnedOnly', 'inStats', 'countOverride'],
  computed: {
    lastNewsDate () {
      return this.$store.getters.lastNewsDate
    },
    id() {
      return 'notice-container-' + nanoid(10)
    },
    coin() {
      return this.$store.getters.coin
    },
    maxHeightStyle() {
      let vm = this
      if (vm.infiniteScroll) {
        return vm.containerHeight + 'px;'
      } else {
        return 'fit-content;'
      }
    }
  },
  watch: {
    coin(newValue, oldValue) {
      let vm = this
      vm.fetch(true)
    }
  },
  async mounted() {
    let vm = this

    vm.fetch(false)

    let container = document.getElementById(vm.id)
    container.addEventListener('scroll', vm.reprintShadowScroll)
    window.addEventListener('resize', vm.reprintShadowScroll);

    let boxShadowScrollLeft = document.getElementsByClassName('box-shadow-container-top')[0]
    let boxShadowScrollRight = document.getElementsByClassName('box-shadow-container-bottom')[0]

    boxShadowScrollLeft.addEventListener('click', (e) => {
      vm.isHoveringBottom = false
      vm.isHoveringTop = true
      vm.doScroll('top', vm.scrollMovement * 8)
      vm.isHoveringTop = false
    });

    boxShadowScrollLeft.addEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringBottom = false
        vm.isHoveringTop = true
        vm.doScroll('top', vm.scrollMovement)
      }
    });

    boxShadowScrollLeft.addEventListener('mouseout', (e) => {
      vm.isHoveringTop = false
    });

    boxShadowScrollRight.addEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringTop = false
        vm.isHoveringBottom = true
        vm.doScroll('bottom', vm.scrollMovement)
      }
    });

    boxShadowScrollRight.addEventListener('mouseout', (e) => {
      vm.isHoveringBottom = false
    });

    boxShadowScrollRight.addEventListener('click', (e) => {
      vm.isHoveringTop = false
      vm.isHoveringBottom = true
      vm.doScroll('bottom', vm.scrollMovement * 8)
      vm.isHoveringBottom = false
    });

    container.addEventListener('mousedown', (e) => {
      vm.isDown = true;
      vm.startY = e.pageY - container.offsetTop;
      vm.scrollTop = container.scrollTop;
    });
    container.addEventListener('mouseleave', () => {
      vm.isDown = false;
    });
    container.addEventListener('mouseup', () => {
      vm.isDown = false;
    });
    container.addEventListener('mousemove', (e) => {
      if (!vm.isDown) return;
      e.preventDefault();
      vm.isHoveringTop = false
      vm.isHoveringBottom = false
      const x = e.pageY - container.offsetTop;
      const walk = (x - vm.startY) * 1; // scroll-normal
      container.scrollTop = vm.scrollTop - walk;
    });
  },
  beforeUnmount() {
    let vm = this

    let container = document.getElementById(vm.id)
    container.removeEventListener('scroll', vm.reprintShadowScroll)
    window.removeEventListener('resize', vm.reprintShadowScroll);

    let boxShadowScrollLeft = document.getElementsByClassName('box-shadow-container-top')[0]
    let boxShadowScrollRight = document.getElementsByClassName('box-shadow-container-bottom')[0]

    boxShadowScrollLeft.removeEventListener('click', (e) => {
      vm.isHoveringBottom = false
      vm.isHoveringTop = true
      vm.doScroll('top', vm.scrollMovement * 8)
      vm.isHoveringTop = false
    });

    boxShadowScrollLeft.removeEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringBottom = false
        vm.isHoveringTop = true
        vm.doScroll('top', vm.scrollMovement)
      }
    });

    boxShadowScrollLeft.removeEventListener('mouseout', (e) => {
      vm.isHoveringTop = false
    });

    boxShadowScrollRight.removeEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringTop = false
        vm.isHoveringBottom = true
        vm.doScroll('bottom', vm.scrollMovement)
      }
    });

    boxShadowScrollRight.removeEventListener('mouseout', (e) => {
      vm.isHoveringBottom = false
    });

    boxShadowScrollRight.removeEventListener('click', (e) => {
      vm.isHoveringTop = false
      vm.isHoveringBottom = true
      vm.doScroll('bottom', vm.scrollMovement * 8)
      vm.isHoveringBottom = false
    });

    container.removeEventListener('mousedown', (e) => {
      vm.isDown = true;
      vm.startY = e.pageY - container.offsetTop;
      vm.scrollTop = container.scrollTop;
    });
    container.removeEventListener('mouseleave', () => {
      vm.isDown = false;
    });
    container.removeEventListener('mouseup', () => {
      vm.isDown = false;
    });
    container.removeEventListener('mousemove', (e) => {
      if (!vm.isDown) return;
      e.preventDefault();
      vm.isHoveringTop = false
      vm.isHoveringBottom = false
      const x = e.pageY - container.offsetTop;
      const walk = (x - vm.startY) * 1; // scroll-normal
      container.scrollTop = vm.scrollTop - walk;
    });
  },
  methods: {
    clearNews () {
      let vm = this
      vm.$store.dispatch('setLastNewsDate', +new Date())
      vm.$store.dispatch('setNewsCount', 0)
    },
    fetch(clear) {
      let vm = this

      if ((!vm.isLoading && !vm.noMoreFetch) || clear) {
        vm.isLoading = true

        let url = '/notice'

        let count = vm.countDesktop
        if (vm.countOverride) count = vm.countOverride
        else {
          count = vm.countMobile
          if (document.documentElement.clientWidth <= 768) count = vm.countMobile
          else count = vm.countDesktop
        }

        let skip = clear ? 0 : vm.list.length
        if (skip > 0) count = vm.countDesktop

        let obj = {
          coin: vm.coin,
          count: count,
          skip: skip
        }

        apiGetSupportV4(vm, url, obj, function (data) {
          if (data.success) {
            if (clear) {
              vm.list = data.data
              vm.pinned = data.pinned

              vm.$store.dispatch('setLastNewsDate', vm.list[0].at)
              if (vm.pinned.length > 0 && vm.pinned[0].at > vm.list[0].at) {
                vm.$store.dispatch('setLastNewsDate', vm.pinned[0].at)
              }
            } else {
              let newCount = 0;
              for (var i = 0; i < data.data.length; i++) {
                if (data.data[i].at > vm.lastNewsDate) newCount++;
                vm.list.push(data.data[i])
              }
              vm.pinned = data.pinned;
              vm.$store.dispatch('setNewsCount', newCount)
            }

            if (data.data.length === 0) {
              // there is no more news
              vm.noMoreFetch = true
            }
          } else {
            vm.$store.dispatch('notifyError', data.msg)
          }
        }, function (err) {
          console.error(err.message)
          vm.$store.dispatch('notifyError', err.message)
        }, function () {
          vm.isLoading = false
          setTimeout(function () {
            vm.reprintShadowScroll()
          }, 100)
        })
      }
    },
    loadMoreNews() {
      let vm = this
      let noticeContainer = document.getElementById(vm.id)
      vm.containerHeight = noticeContainer.offsetHeight
      vm.infiniteScroll = true

      vm.fetch(false)
    },
    reprintShadowScroll(e) {
      let vm = this
      let container = document.getElementById(vm.id)

      if (!container || container.clientHeight === 0) {
        setTimeout(function () {
          vm.reprintShadowScroll()
        }, 100)
      } else {
        if (container.scrollHeight - container.clientHeight === 0) {
          // There is no scroll
          vm.showTopShadow = false
          vm.showBottomShadow = false
        } else {
          if (container.scrollTop !== 0) vm.showTopShadow = true
          else vm.showTopShadow = false

          if ((container.scrollHeight - container.clientHeight) - container.scrollTop < 1.1) {
            vm.showBottomShadow = false
            if (!vm.noMoreFetch) vm.fetch(false)
          } else {
            vm.showBottomShadow = true
          }
        }
      }
    },
    doScroll(direction, amount) {
      let vm = this

      if (vm.isHoveringTop && vm.isHoveringBottom) {
        if (direction === 'top') vm.isHoveringBottom = false
        if (direction === 'bottom') vm.isHoveringTop = false
      }

      let container = document.getElementById(vm.id)

      if (container.scrollTop === 0) {
        vm.isHoveringTop = false
      } else if ((container.scrollHeight - container.clientHeight) - container.scrollTop < 1.1) {
        vm.isHoveringBottom = false
      }

      if (vm.isHoveringTop || vm.isHoveringBottom) {
        let topScroll = container.scrollTop
        if (direction === 'top') topScroll = container.scrollTop - amount
        else topScroll = container.scrollTop + amount

        if (topScroll < 0) topScroll = 0

        container.scrollTo({
          top: topScroll,
          left: 0,
          behavior: 'smooth'
        })

        setTimeout(function () {
          if (vm.isHoveringTop && vm.isHoveringBottom) {
            if (direction === 'top') vm.isHoveringBottom = false
            if (direction === 'bottom') vm.isHoveringTop = false
          }
          if (vm.isHoveringTop && direction === 'top') vm.doScroll(direction, amount)
          if (vm.isHoveringBottom && direction === 'bottom') vm.doScroll(direction, amount)
        }, 50)
      }
    },
    isTouchEvent() {
      return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
  }
}
</script>

<style lang="stylus" scoped>
.more-news
  padding-left: 15px;
  font-size 13px
  a
    display: flex;
    align-items: center;
.infinite-container
  overflow-y: auto

.news-super-container
  position relative

.notice-container
  scrollbar-width: none;
  padding: 15px 0px;

.notice-
  &:first-child
    margin-top 0px
  .notice-content-
    transition background .5s ease
    padding: 2.5px 5px;
    &.new
      background: #ebffeb;
      // padding: 2.5px 5px;
      border-radius: 2.5px;

.time-container-
  display flex
  align-items center
  .tweet
    margin-top: -6px;
    .separator-circle
      margin: -0.5px 7.5px 0px 7.5px;
    i
      color rgb(29, 155, 240)
.in-stats
  margin-top 0
.no-spacing
  margin 0
  padding 0
.box-shadow-container
  width 100%
  height 20px
  position absolute
  z-index: 10;
  display flex
  align-items center
  padding 5px
  cursor pointer
  -webkit-tap-highlight-color: transparent;
  &.top
    top 0px
    left 0px
    box-shadow: inset 0px 10px 14px -13px #000;
  &.bottom
    bottom 0px
    left 0px
    box-shadow: inset 0px -10px 14px -13px #000;

.x-icon
  img
    width: 12px;
    vertical-align: middle;

.pinned-container
  padding-top 15px
  margin-bottom -10px
  .notice-content-
    box-shadow: 0 1px 0px #efefef;
    padding-bottom: 5px;

.notice-container-.in-coin-news
  margin: 0;
  margin-top: -25px
  &.pinned-only
    .pinned-container
      margin-top: 25px;


.notice-container-.pinned-only
  .pinned-container
    .notice- .time-
      margin-bottom 0px
    .notice-:not(:last-child)
      .notice-content-
        margin-bottom 0px
        padding-bottom 0px


@media (max-width: 550px)
  .notice-container-.pinned-only
    margin: 30px 0px 30px 0px;
  .notice-container-.pinned-only.in-stats
    margin: 0
    margin-bottom 25px

html.dark, body.dark
  .box-shadow-container
    &.top
      box-shadow: inset 0px 10px 13px -13px #fff;
    &.bottom
      box-shadow: inset 0px -10px 13px -13px #fff;
  .notice-
    .notice-content-
      &.new
        color #000;
        >>> a
          color #000 !important;
        

.notice-container::-webkit-scrollbar {
  display none
}
</style>



// WEBPACK FOOTER //
// c_news.vue?cb79ffa0